import {
  REQUEST_NOTICE_LIST,
  REQUEST_NOTICE,
} from './mutation-types'

export default {
  [REQUEST_NOTICE_LIST](state, receivedData) {
    state.noticeList = receivedData.content;
    state.noticeListCount = receivedData.totalElements;
  },
  [REQUEST_NOTICE](state, receivedData) {
    state.notice = receivedData
  },
}